"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalPolicyDetailsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordion_1 = require("../../../../components/FalconAccordion");
var AnnualMotorRenewalPolicyDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalPolicyDetailsWidget, _super);
    function AnnualMotorRenewalPolicyDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        var paymentOption = _this.props.interaction.factors ? _this.props.interaction.factors.premiumType : undefined;
        _this.state = {
            paymentOption: paymentOption
        };
        return _this;
    }
    AnnualMotorRenewalPolicyDetailsWidget.prototype.render = function () {
        var referrerJourney = window.sessionStorage.getItem("referrerJourney");
        var isAccordionOpen = referrerJourney === "mtcRenewal";
        return ((0, jsx_runtime_1.jsx)("div", { className: "section-panel text-center annual-motor-renewal policy-details-section mt-5", children: (0, jsx_runtime_1.jsx)("div", { className: "mt-3 panel-detail-output-entity", children: (0, jsx_runtime_1.jsx)(FalconAccordion_1.FalconAccordion, { isOpen: isAccordionOpen, togglePositionTop: true, toggleHidden: (0, jsx_runtime_1.jsxs)("div", { className: "toggle d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-18 toggle-title collapsed-title", children: "Policy details" }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon expand-icon" })] }), toggleShown: (0, jsx_runtime_1.jsxs)("div", { className: "toggle toggle-show d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-18 toggle-title", children: "Policy details" }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon collapse-icon" })] }), children: this.renderPolicyDetails() }) }) }));
    };
    AnnualMotorRenewalPolicyDetailsWidget.prototype.renderPolicyDetails = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "margin-bottom-24 padding-bottom-16", children: (0, jsx_runtime_1.jsxs)("div", { className: "accordion-content reset-paddings grid-make-2-col", children: [this.renderQuestions(), (0, jsx_runtime_1.jsxs)("div", { className: "detail pt-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "detail-key", children: "Protected no claim discount:" }), (0, jsx_runtime_1.jsx)("div", { className: "detail-value", children: this.props.interaction.policyHolder.ncd.doNotDisclose ? "Included" : "Not included" })] })] }) }));
    };
    ;
    AnnualMotorRenewalPolicyDetailsWidget.prototype.renderQuestions = function () {
        return (0, jsx_runtime_1.jsx)(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    return AnnualMotorRenewalPolicyDetailsWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorRenewalPolicyDetailsWidget = AnnualMotorRenewalPolicyDetailsWidget;
//# sourceMappingURL=AnnualMotorRenewalPolicyDetailsWidget.js.map